import { render, staticRenderFns } from "./caseGoodsList.vue?vue&type=template&id=1a8b4149&scoped=true&"
import script from "./caseGoodsList.vue?vue&type=script&lang=js&"
export * from "./caseGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./caseGoodsList.vue?vue&type=style&index=0&id=1a8b4149&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8b4149",
  null
  
)

export default component.exports